import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  personaId: z.string().min(1),
  isEnabled: z.boolean(),
  customPriority: z.number().int().min(1).max(100).optional().nullable(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  setting: {
    personaId: string;
    isEnabled: boolean;
    customPriority: number | null;
  };
};

export const postPersonaSetting = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/personas/settings/update', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
